import { Controller } from "@hotwired/stimulus"
import { mount } from "pele"

export default class extends Controller {
  static targets = ["entry"]

  entryTargetConnected(target) {
    mount(target, target.innerText)
  }
}
